/**
 * Remembering the free-mock access key on this device.
 *
 * The key is what gets a student into their seat, so it is deliberately kept to
 * this one browser and cleared the moment they sign out. Every access is
 * wrapped: private-mode browsers and "block site data" settings make
 * localStorage throw rather than return null, and being unable to remember a
 * key must never stop someone entering it by hand.
 */

const STORAGE_KEY = "free-mock:access-key"

export function readStoredAccessKey(): string | null {
    if (typeof window === "undefined") return null
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY)
        if (!raw) return null
        const cleaned = raw.replace(/\D/g, "")
        return cleaned.length === 6 ? cleaned : null
    } catch {
        return null
    }
}

export function storeAccessKey(key: string): void {
    if (typeof window === "undefined") return
    try {
        window.localStorage.setItem(STORAGE_KEY, key)
    } catch {
        // Nothing to do — the student simply retypes it next time.
    }
}

export function clearStoredAccessKey(): void {
    if (typeof window === "undefined") return
    try {
        window.localStorage.removeItem(STORAGE_KEY)
    } catch {
        // Ignored for the same reason.
    }
}
